import Component from 'flarum/common/Component';

export default class HomeHero extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	// This is to extend
	content() {
		return [];
	}

	view() {
		if (!this.content()?.length) {
			return null;
		}

		return (
			<div className='container'>
				<div className='HomeHero'>{this.content()}</div>
			</div>
		);
	}
}
